import { Home, ShoppingCart, ChefHat, BarChart3, MoreHorizontal } from 'lucide-react'
import { useLocation, useNavigate } from 'react-router-dom'
import { NavTab } from './NavTab'
import { useNavAttention } from '../../hooks/useNavAttention'

const TABS = [
  { key: 'home',     label: 'Home',     Icon: Home,           route: '/home',     color: '#2B4A3A' },
  { key: 'shop',     label: 'Shop',     Icon: ShoppingCart,   route: '/shop',     color: '#B5683A' },
  { key: 'recipes',  label: 'Recipes',  Icon: ChefHat,        route: '/recipes',  color: '#D4A574' },
  { key: 'spending', label: 'Spending', Icon: BarChart3,      route: '/spending', color: '#7A6B50' },
  { key: 'more',     label: 'More',     Icon: MoreHorizontal, route: '/more',     color: '#9A8B73' },
] as const

export function BottomNav() {
  const location  = useLocation()
  const navigate  = useNavigate()
  const attention = useNavAttention()

  return (
    <nav
      aria-label="Primary"
      className="fixed bottom-0 left-0 right-0 z-40 pb-[env(safe-area-inset-bottom)]"
    >
      <div className="mx-3 mb-3 flex items-stretch rounded-[20px] border border-border-sand bg-paper px-1 py-2 shadow-sm">
        {TABS.map((tab) => {
          const isActive =
            location.pathname === tab.route ||
            location.pathname.startsWith(tab.route + '/')

          const tabAttention =
            tab.key === 'home'    ? attention.home :
            tab.key === 'shop'    ? attention.shop :
            tab.key === 'recipes' ? attention.recipes :
            null

          return (
            <NavTab
              key={tab.key}
              label={tab.label}
              Icon={tab.Icon}
              active={isActive}
              accentColor={tab.color}
              onClick={() => navigate(tab.route)}
              attention={isActive ? null : tabAttention}
            />
          )
        })}
      </div>
    </nav>
  )
}
